<template>
    <div class="right-category">
        <div class="charts-title">
            <div
                v-for="(item, i) in xAxis.data"
                :key="id + i">
                <em :style="{'background': colors[i]}"></em>
                <span>{{ item }}</span> <br>
                <span>{{ series[0][i] }}</span>
            </div>
        </div>
        <div class="my-charts" :id="id"></div>
    </div>
</template>

<script>
import * as echarts from 'echarts5'
export default {
    props: {
        id: {
            type: String,
            default: ''
        },
        series: {
            type: Array,
            default: () => { return [] }
        },
        xAxis: {
            type: Object,
            default: () => { return {} }
        },
        yAxis: {
            type: Object,
            default: () => { return {} }
        },
    },
    data() {
        let _this = this
        return {
            // width: 110,
            // height: 110,
            colors: ['#00D1C8', '#FF5359', '#0077FF', '#F9DA4F', '#7D5AFB', '#ED772E', '#00D1C8', '#FF5359', '#0077FF', '#F9DA4F', '#7D5AFB', '#ED772E'],
            options: {
                polar: {
                    radius: [10, '80%']
                },
                angleAxis: {
                    max: Math.max.apply(null, this.series[0]) + 100,
                    startAngle: 90,
                    axisLabel: {
                        fontSize: 5
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: ["rgba(255, 255, 255, 0.15)"]
                        }
                    },
                },
                radiusAxis: {
                    type: 'category',
                    show: false,
                    data: _this.xAxis.data
                },
                series: {
                    type: 'bar',
                    // data: ,
                    coordinateSystem: 'polar',
                    label: {
                        position: 'middle',
                        formatter: '{b}: {c}'
                    }
                }
            }
        }
    },
    mounted() {
        let newSeries =  this.series[0].map((item, i) => {
            return {
                value: item,
                itemStyle: {
                    color: this.colors[i]
                }
            }
        })
        this.options.series.data = newSeries
        this.myCharts()
    },
    methods: {
        myCharts() {
            const _this = this
            const myCharts = echarts.init(document.getElementById(_this.id))
            // myCharts.resize({
            //     width: `${this.width}px`,
            //     height: `${this.height}px`
            // })
            myCharts.setOption(_this.options)
        }
    }
}
</script>

<style lang="scss" scoped>
.right-category {
    position: relative;
    width: 100%;
    height: 650px;
    display: flex;
    flex-direction: column;
    .charts-title {
        font-size: 16px;
        height: 160px;
        display: flex;
        flex-wrap: wrap;
        flex-shrink: 0;
        margin-top: 30px;
        > div {
            margin-right: 10px;
            padding-left: 20px;
            position: relative;
            > em {
                width: 5px;
                height: 5px;
                border-radius: 50%;
                position: absolute;
                top: 10px;
                left: 0;
            }
        }
    }
    .my-charts {
        width: 100%;
        flex: 1;
    }
}
</style>